/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/self-closing-comp */
/* eslint-disable prefer-const */
import React, { useState } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useAuth } from '../contexts/authContext';
import { useContact } from '../contexts/contactContext';
import {
    dashboardListRoute,
    DashboardRoutesComponent,
    OnlineRoutesComponent,
    listGeneratorsRoute,
    listReadyKits,
    detailRoute,
    invoicesListRoute,
    InvoicesRoutesComponent,
    invoiceDetailRoute,
    budgetsListRoute,
    BudgetsRoutesComponent,
    userProfileRoute,
    companyProfileRoute,
    ProfileRoutesComponent,
    pointRoutesComponent,
    pointGeneralInfoRoute,
    pointStatementRoute,
    pointStoreRoute,
    wishlistRoute,
    regulationRoute,
    pointManagementRoute,
    listBlackFridayRoute,
    creditCardAnalysisListRoute,
    CreditCardAnalysisRoutesComponent,
} from './config';
import FloatConsultantContactButton from '../components/FloatButton';
import {
    OthersPaymentMethodsListRouteComponent,
    othersPaymentMethodsListRoute,
} from './config/othersPaymentMethodsList.route';
import { Role } from '../constants/role';
import userHasRoles from '../utils/userHasRoles';

const AppRoutes: React.FC = () => {
    const auth = useAuth();
    const { consultants } = useContact();
    const [showFloat, setShowFloat] = useState(true);

    let user = {
        ...auth.user,
    };

    let userState = user && user.seller && user.seller.erpState;
    let consultantInformation: any = null;

    if (userState && consultants.length > 0) {
        consultantInformation = consultants.find(
            (consultant: any) => consultant.state === userState,
        );
    }

    const handleToggleFloat = () => {
        setShowFloat((showFloat) => !showFloat);
    };

    const isAdministrator = userHasRoles(user, [Role.Administrator]);

    const ProtectedRoute = ({ component: Component, path }: any) => (
        <Route
            path={path}
            render={() =>
                isAdministrator ? (
                    <Component />
                ) : (
                    <Redirect to={dashboardListRoute.path} />
                )
            }
        />
    );

    return (
        <>
            <Switch>
                <Route
                    path={dashboardListRoute.path}
                    component={DashboardRoutesComponent}
                    exact
                />
                <ProtectedRoute
                    path={listReadyKits.path}
                    component={OnlineRoutesComponent}
                />
                <ProtectedRoute
                    path={listGeneratorsRoute.path}
                    component={OnlineRoutesComponent}
                />
                <ProtectedRoute
                    path={detailRoute.path}
                    component={OnlineRoutesComponent}
                />
                <ProtectedRoute
                    path={invoicesListRoute.path}
                    component={InvoicesRoutesComponent}
                />
                <ProtectedRoute
                    path={invoiceDetailRoute.path}
                    component={InvoicesRoutesComponent}
                />
                <ProtectedRoute
                    path={budgetsListRoute.path}
                    component={BudgetsRoutesComponent}
                />
                <ProtectedRoute
                    path={creditCardAnalysisListRoute.path}
                    component={CreditCardAnalysisRoutesComponent}
                />
                <ProtectedRoute
                    path={pointGeneralInfoRoute.path}
                    component={pointRoutesComponent}
                />
                <ProtectedRoute
                    path={pointStatementRoute.path}
                    component={pointRoutesComponent}
                />
                <ProtectedRoute
                    path={pointStoreRoute.path}
                    component={pointRoutesComponent}
                />

                <ProtectedRoute
                    path={wishlistRoute.path}
                    component={pointRoutesComponent}
                />

                <ProtectedRoute
                    path={regulationRoute.path}
                    component={pointRoutesComponent}
                />

                <ProtectedRoute
                    path={pointManagementRoute.path}
                    component={pointRoutesComponent}
                />

                <ProtectedRoute
                    path={userProfileRoute.path}
                    component={ProfileRoutesComponent}
                />
                <ProtectedRoute
                    path={companyProfileRoute.path}
                    component={ProfileRoutesComponent}
                />
                <ProtectedRoute
                    path={listBlackFridayRoute.path}
                    component={OnlineRoutesComponent}
                />
                <ProtectedRoute
                    path={othersPaymentMethodsListRoute.path}
                    component={OthersPaymentMethodsListRouteComponent}
                />
            </Switch>
            {consultantInformation && (
                <>
                    <FloatConsultantContactButton
                        consultantNumber={
                            consultantInformation.consultantWhatsapp
                        }
                        showFloat={showFloat}
                        toggle={handleToggleFloat}
                    />
                </>
            )}
        </>
    );
};

export default AppRoutes;
